<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">クラス編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'class-id-detail', params: { id } }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_class.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmEdited)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporationDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">ブランド名（ブランドID）</th>
                <td />
                <td>{{ currentBrandDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">教場名（教場ID）</th>
                <td />
                <td>{{ currentSchoolDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">コース名（コースID）</th>
                <td />
                <td>{{ currentCourseDisplay }}</td>
              </tr>
              <TextField
                v-model="currentTamaiClass.name"
                extraRules="required"
                label="クラス名"
                placeholder="入力してください"
              />
              <TextField
                v-model="currentTamaiClass.nameReading"
                extraRules="required"
                label="クラス名フリガナ"
                placeholder="入力してください"
              />
              <tr>
                <th scope="row">クラスID（自動生成）</th>
                <td />
                <td>{{ currentTamaiClass.uid }}</td>
              </tr>
              <ChoiceField
                v-model="mainTeacherChoiceFieldModel"
                extraRules="required_select"
                label="先生名（担当・メイン）"
                placeholder="選択してください"
                resourceType="teacher"
                modelFieldName="mainTeacher"
                :formData="currentTamaiClass"
                :excludeItems="teacherChose"
              />

              <!-- Note that index is from 1 to 8 -->
              <template v-for="index in maxNumOfTeacher">
                <ChoiceField
                  v-if="index == 1 || currentTamaiClass[teacherKeyAtIndex(index - 1)].id"
                  :key="index"
                  v-model="currentTamaiClass[teacherKeyAtIndex(index)].name"
                  :label="teacherLabelAtIndex(index)"
                  placeholder="選択してください  / サブの先生は最大8名まで登録可能です"
                  resourceType="teacher"
                  :modelFieldName="teacherKeyAtIndex(index)"
                  :formData="currentTamaiClass"
                  :excludeItems="teacherChose"
                >
                  <template v-slot:afterInput>
                    <button
                      type="button"
                      class="btn-sm"
                      @click="releaseTeacher(index)"
                      v-if="currentTamaiClass[teacherKeyAtIndex(index)].id"
                    >
                      解除
                    </button>
                  </template>
                </ChoiceField>
              </template>
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import isEmpty from 'lodash/isEmpty';
import { ValidationObserver } from 'vee-validate';
import TextField from '@/components/forms/TextField.vue';
import ChoiceField from '@/components/forms/ChoiceField.vue';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
} from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    ValidationObserver,
    TextField,
    ChoiceField,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeFrom.name != 'choice') {
      store.dispatch('form/clearFormDataStored');
    }

    if (routeTo.params.id) {
      let prevFormData = store.state.form.prevFormData;
      let maxNumOfTeacher = store.state.tamai_class.maxNumOfTeacher;

      if (prevFormData) {
        // Set default value for teacher[idx]
        for (let i = 1; i <= maxNumOfTeacher; i++) {
          if (this.isEmpty(prevFormData[this.teacherKeyAtIndex(i)])) {
            prevFormData[this.teacherKeyAtIndex(i)] = {};
          }
        }

        store.dispatch('tamai_class/restoreFormData', prevFormData).then(() => {
          next();
        });
      } else {
        store.dispatch('tamai_class/fetchTamaiClass', routeTo.params.id).then(() => {
          next();
        });
      }
    } else {
      next();
    }
  },
  computed: {
    teacherChose() {
      let teacherIds = [];

      if (!isEmpty(this.currentTamaiClass.mainTeacher)) {
        teacherIds.push(this.currentTamaiClass.mainTeacher.id);
      }

      for (let index = 1; index <= this.maxNumOfTeacher; index++) {
        const teacher = this.currentTamaiClass[this.teacherKeyAtIndex(index)];

        if (!isEmpty(teacher)) {
          teacherIds.push(teacher.id);
        }
      }

      return { teacherId: teacherIds };
    },
    currentTamaiClass() {
      if (this.tamai_class.editingTamaiClass) {
        return this.tamai_class.editingTamaiClass;
      } else {
        return this.tamai_class.tamaiClass;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentTamaiClass.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentTamaiClass.brand);
    },
    currentSchoolDisplay() {
      return basicSchoolNameIdPresent(this.currentTamaiClass.school);
    },
    currentCourseDisplay() {
      return basicCourseNameIdPresent(this.currentTamaiClass.course);
    },
    mainTeacherChoiceFieldModel() {
      if (this.currentTamaiClass.mainTeacher) {
        return this.currentTamaiClass.mainTeacher.name;
      }
      return '';
    },
    ...mapState(['tamai_class']),
    ...mapGetters('tamai_class', ['maxNumOfTeacher']),
  },
  methods: {
    releaseTeacher(toIndex) {
      if (toIndex >= 1 && toIndex <= this.maxNumOfTeacher) {
        for (let index = toIndex; index <= this.maxNumOfTeacher; index++) {
          const nextIndex = index + 1;
          const nextTeacherId = this.currentTamaiClass[this.teacherKeyAtIndex(nextIndex)];
          if (nextTeacherId) {
            this.currentTamaiClass[this.teacherKeyAtIndex(index)] = nextTeacherId;
            this.$logger.debug('Swap teacher at index ' + nextIndex + ' to index ' + index);
          } else {
            this.currentTamaiClass[this.teacherKeyAtIndex(index)] = {};
            this.$logger.debug('Release teacher at index ' + index);
            break;
          }
        }
      }
    },
    teacherLabelAtIndex(index) {
      return `先生名（担当・サブ${index})`;
    },
    teacherKeyAtIndex(index) {
      return 'teacher' + index;
    },
    confirmEdited() {
      this.$logger.debug('Started Editing: ' + JSON.stringify(this.currentTamaiClass));
      this.startEditingTamaiClass(this.currentTamaiClass);
      this.$router.push({ name: 'class-id-confirm', params: { id: this.id } });
    },
    ...mapActions('tamai_class', ['startEditingTamaiClass']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
